export default __webpack_public_path__ + "static/shop-best-sellers-mobile-b8ef8934f20557429707c98788c4d113.png";